module.exports = __webpack_public_path__ + "img/20170319-3.985c4c91.jpeg";